import { Link } from "react-router-dom";
import { LogOut, Settings as SettingsIcon, UserCircle, LifeBuoy } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

function initials(name?: string | null, email?: string | null) {
  const src = name || email || "U";
  const parts = src.split(/[\s@.]+/).filter(Boolean);
  return (parts[0]?.[0] || "U").toUpperCase() + (parts[1]?.[0] || "").toUpperCase();
}

export function ProfileMenu() {
  const { user, profile, signOut, activeRole } = useAuth();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-9 w-9 p-0 rounded-full bg-gradient-to-br from-primary/80 to-primary text-primary-foreground font-semibold text-xs"
          aria-label="Account menu"
        >
          {initials(profile?.full_name, user?.email)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 rounded-2xl">
        <DropdownMenuLabel className="font-normal">
          <p className="text-sm font-semibold text-foreground truncate">
            {profile?.full_name || "Account"}
          </p>
          <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
          {activeRole && (
            <p className="text-[10px] font-semibold uppercase tracking-wider text-primary mt-1">
              {activeRole}
            </p>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/settings">
            <UserCircle className="h-4 w-4 mr-2" />
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/settings?tab=preferences">
            <SettingsIcon className="h-4 w-4 mr-2" />
            Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/methodology">
            <LifeBuoy className="h-4 w-4 mr-2" />
            Help & methodology
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => signOut()}>
          <LogOut className="h-4 w-4 mr-2" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
